const LIST_SELECTOR_ITERATOR_MAX_OPTIONS = 50;

export const getListSelectorIteratorMaxOptions = () => {
  return LIST_SELECTOR_ITERATOR_MAX_OPTIONS;
};
